import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {StyleFields} from 'Event/auth/Login/SubmitButton/SubmitButtonConfig'
import {useAttendeeVariables} from 'Event'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function SubmitButtonConfig() {
  const saveTemplate = useSaveTemplate()
  const {signUp} = useTemplate()
  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()

  const save = (data: any) => {
    const label = replaceAtPath(
      data,
      'signUp.buttonText',
      '{{sign_up_button_text}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        sign_up_button_text: label ?? '',
      }),
    })
  }

  const {
    form: {register},
  } = useConfig()

  return (
    <Config title="Submit Button" onSave={save}>
      <SettingsPanel>
        <TextField
          label="Submit Label"
          name="signUp.buttonText"
          defaultValue={v(signUp.buttonText)}
          inputProps={{
            'aria-label': 'submit button label',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <StyleFields />
      </StylingPanel>
    </Config>
  )
}
